// @ts-ignore

import qrCodeGenerator from 'qr.js'

import { ITableColumn } from '@makyoapp/makyo-sdk/models/Table'

import { Cell, ICell } from '.'
import { getQrValue } from './helpers/qrcode'

interface QrCrypto {
  amount: string
  crypto: string
  message: string
  receiver: string
}

interface QrEmail {
  message: string
  subject: string
  to: string
}

interface QrSMS {
  message: string
  to: string
}

interface QrVCard {
  address: string
  city: string
  company: string
  country: string
  email: string
  fax: string
  firstName: string
  job: string
  lastName: string
  mobilePhone: string
  phone: string
  state: string
  website: string
  zip: string
}

// TODO: need to improvement
export interface IQRCodeColumnSettings {
  qrCrypto: QrCrypto
  qrEmail: QrEmail
  qrFile: string
  qrSMS: QrSMS
  qrText: string
  qrType: string
  qrURL: string
  qrVCard: QrVCard
}

export interface IQRCodeColumn extends ITableColumn {
  Settings: IQRCodeColumnSettings
}

export interface IQRCodeCell extends ICell {
  settings: IQRCodeColumnSettings
  dataURL: string
}

export class QRCodeCell implements IQRCodeCell {
  value: Cell
  settings: IQRCodeColumnSettings
  dataURL: string

  // note: the barcode cell will initialize its value from settings
  constructor(value: null, settings: IQRCodeColumnSettings) {
    this.value = getQrValue(settings) // assume that the value of settings already parsed
    this.settings = {
      qrCrypto: settings.qrCrypto,
      qrEmail: settings.qrEmail,
      qrFile: settings.qrFile,
      qrSMS: settings.qrSMS,
      qrText: settings.qrText,
      qrType: settings.qrType,
      qrURL: settings.qrURL,
      qrVCard: settings.qrVCard,
    }
    this.dataURL = generateQRCodeURL(this.value as string)
  }

  toString(): string {
    return this.dataURL
  }

  toCell<T extends Cell>(value: T) {
    // todo
    return this
  }
}

export function generateQRCodeURL(
  value: string,
  size: number = 256,
  bgColor: string = '#FFFFFF',
  fgColor: string = '#000000'
) {
  if (!value) return ''

  try {
    const qrCode = qrCodeGenerator(value, {
      typeNumber: -1,
      errorCorrectLevel: 1,
    })

    const cells = qrCode.modules
    const numCells = cells.length

    // Create SVG
    const svgNode = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svgNode.setAttribute('viewBox', `0 0 ${numCells} ${numCells}`)
    svgNode.setAttribute('height', size.toString())
    svgNode.setAttribute('width', size.toString())

    // Background path (white squares)
    const bgD = cells
      .map((row: boolean[], rowIndex: number) =>
        row.map((cell, cellIndex) => (!cell ? `M ${cellIndex} ${rowIndex} l 1 0 0 1 -1 0 Z` : '')).join(' ')
      )
      .join(' ')

    if (bgD.trim()) {
      const bgPath = document.createElementNS('http://www.w3.org/2000/svg', 'path')
      bgPath.setAttribute('d', bgD)
      bgPath.setAttribute('fill', bgColor)
      svgNode.appendChild(bgPath)
    }

    // Foreground path (black squares)
    const fgD = cells
      .map((row: boolean[], rowIndex: number) =>
        row.map((cell, cellIndex) => (cell ? `M ${cellIndex} ${rowIndex} l 1 0 0 1 -1 0 Z` : '')).join(' ')
      )
      .join(' ')

    if (fgD.trim()) {
      const fgPath = document.createElementNS('http://www.w3.org/2000/svg', 'path')
      fgPath.setAttribute('d', fgD)
      fgPath.setAttribute('fill', fgColor)
      svgNode.appendChild(fgPath)
    }

    // Convert to data URL
    const xmlSerializer = new XMLSerializer()
    const svg = xmlSerializer.serializeToString(svgNode)
    const base64 = window.btoa(svg)
    return `data:image/svg+xml;base64,${base64}`
  } catch (error) {
    console.error('Error generating QR code:', error)
    return ''
  }
}
